import { UNIVERSAL_ACTIVATION_FLOW } from 'const/constants'
import getSessionAuthFlow from './getSessionAuthFlow'

const isUniversalActivation = () => {
  return getSessionAuthFlow() === UNIVERSAL_ACTIVATION_FLOW
}

export default isUniversalActivation
